import { CommonNS } from "../../../../Common/CommonNS.js";
export class LineView {
  constructor({ document }) {
    this._line_el = document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "line"
    );
    this._line_el.setAttributeNS(null, "x1", "0");
    this._line_el.setAttributeNS(null, "y1", "0");
    this._line_el.setAttributeNS(null, "x2", "0");
    this._line_el.setAttributeNS(null, "y2", "0");
    this._line_el.setAttributeNS(null, "stroke", "#B1B1B1");
    this._line_el.setAttributeNS(null, "stroke-width", "1");
    this._line_el.setAttributeNS(null, "vector-effect", "non-scaling-stroke");
  }
  setPosition1({ x, y }) {
    this._line_el.setAttributeNS(null, "x1", `${x}`);
    this._line_el.setAttributeNS(null, "y1", `${y}`);
  }
  setPosition2({ x, y }) {
    this._line_el.setAttributeNS(null, "x2", `${x}`);
    this._line_el.setAttributeNS(null, "y2", `${y}`);
  }
  hide() {
    this._line_el.style.display = "none";
  }
  show() {
    this._line_el.style.display = "";
  }
  getEl() {
    return this._line_el;
  }
}
